const Links = {
	PlayStore: 'https://play.google.com/store/apps/details?id=com.GoodlifeTechnology.PTMomentum&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
	AppStore: 'https://apps.apple.com/us/app/pt-momentum/id943755187?mt=8',
	ApplicationProtocol: 'ptmomentum://'
}

export default Links;